import AOS from 'aos'
import createjs from 'preload-js'
import gsap, {Power3} from '@/plugins/gsap';
import ScrollTrigger from '@/plugins/gsap/ScrollTrigger';
import {isMobile} from "mobile-device-detect";
gsap.registerPlugin(ScrollTrigger);

const gh = {
    // app the params - craft cloud auto appends stuff.  so the
    formatFeedUrl(slug) {
        let base = window.config.apiroot + slug;
        let tokenParam = window.config.craftApiPreviewToken; // e.g. "token=abc123"
        let separator = base.includes('?') ? '&' : '?';
        let url = base + separator + tokenParam;

        // Remove duplicate "token" params, keeping only the first occurrence
        try {
            const urlObj = new URL(url);
            const firstTokenValue = urlObj.searchParams.get('token');
            if (firstTokenValue !== null) {
                urlObj.searchParams.delete('token');
                urlObj.searchParams.set('token', firstTokenValue);
                url = urlObj.toString();
            }
        } catch (e) {
            // Fallback if URL parsing isn’t supported
            const parts = url.split('&token=');
            if (parts.length > 2) {
                // Rebuild: keep everything up through the first token, then append the rest without additional "token=" segments
                const [beforeFirst, afterFirst] = [parts[0], parts[1]];
                const rest = afterFirst.split('&').filter(segment => !segment.startsWith('token=')).join('&');
                url = beforeFirst + '&token=' + (afterFirst.split('&')[0]) + (rest ? '&' + rest : '');
            }
        }

        return url;
    },
    globalSectionInit: function() {
        gh.applyParallaxHooks()
        setTimeout(function() {
            gh.applyParallaxHooks()
            gh.aosInit()
        },500)
    },
    applyParallaxHooks: function () {
        const elements = document.querySelectorAll('.parallax-hook');
        elements.forEach((el) => {
            gsap.set(el, { scale: 1.1 });

            const trigger = ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                end: "bottom top",
                scrub: true,
                onUpdate: (self) => {
                    const yShift = gsap.utils.interpolate(-15, 15, self.progress);
                    gsap.to(el, {
                        yPercent: yShift,
                        ease: 'none',
                        overwrite: false,
                        duration: 0.2
                    });
                }
            });

            // Immediately apply the initial scroll position without animation
            const initialShift = gsap.utils.interpolate(-15, 15, trigger.progress);
            gsap.set(el, { yPercent: initialShift });
        });
    },
    aosInit: function() {
        AOS.init({
            offset: 150,
            duration: 700,
            once: true,
        })
        gh.aosRefresh()
    },
    aosRefresh: function() {
        //AOS.refresh()
        AOS.refreshHard()
    },
    setHeightMobile() {
        if (isMobile) {
            const panels = document.getElementsByClassName('sethmob');
            const viewportHeight = window.innerHeight;
            for (let i = 0; i < panels.length; i++) {
                panels[i].style.height = `${viewportHeight}px!important`;
                panels[i].classList.add('device');
            }
        }
    },
    postLoadAssets: function(assets) {
        let queue = new createjs.LoadQueue()
        queue.setMaxConnections(100)
        //queue.on("progress", function(e) {console.log(e)}, this)
        //queue.on("complete", this.postloadComplete, this)
        //queue.on("error", this.postloadError, this)
        queue.loadManifest(assets)
    },
    scrollTo(route, window) {
        const tid = '#section-' + route
        gsap.to(window, {
            duration: 0.5,
            scrollTo:tid,
            easing: Power3.easeInOut
        })
    },
    enableBodyScroll(enable) {
        if (enable) {
            document.body.classList.remove("no-scroll")
            //window.scrollTo(0, gh.bodyScrollY)
            //document.body.style.top = 0
        } else {
            //gh.bodyScrollY = window.scrollY
            document.body.classList.add("no-scroll")
            //document.body.style.top = -gh.bodyScrollY+'px'
        }
    },
    stripSlashesFrontAndBack(val) {
        if (val) {
            val = val.toString()
            if(val.substr(-1) === '/') {
                val = val.substr(0, val.length - 1);
            }
            if(val.substr(0,1) === '/') {
                val = val.substr(1, val.length);
            }
        }
        return val

    },
    genericTextWrapper(html) {
        if (html) {
            // Create a temporary DOM element to manipulate the HTML string
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // Find all oembed elements within the temporary DOM
            const oembedElements = tempDiv.querySelectorAll('oembed[url]');

            oembedElements.forEach(oembed => {
                // Get the URL from the oembed element
                const url = oembed.getAttribute('url');

                // Create an iframe element
                const iframe = document.createElement('iframe');
                iframe.width = "560";  // Set the width of the iframe
                iframe.height = "315"; // Set the height of the iframe
                iframe.src = url.replace("watch?v=", "embed/"); // Convert the YouTube URL to embed format
                iframe.frameBorder = "0"; // Remove the frame border
                iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen";
                //iframe.allowFullscreen = true; // Allow fullscreen

                // Replace the oembed element with the iframe
                oembed.parentNode.replaceChild(iframe, oembed);
            });

            // Return the modified HTML as a string
            return tempDiv.innerHTML;
        } else {
            return null
        }

    },

    // stirps / removes all tags except a, b, i
    removeTags(html) {
        // Create a temporary element to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // List of allowed tags
        const allowedTags = ['b', 'i', 'a', 'em', 'strong'];

        // Function to recursively clean the DOM
        function cleanNode(node) {
            // Loop through child nodes backwards to safely remove elements
            for (let i = node.childNodes.length - 1; i >= 0; i--) {
                const child = node.childNodes[i];

                // If the node is an element node and not in the allowed tags, remove it
                if (child.nodeType === Node.ELEMENT_NODE && !allowedTags.includes(child.nodeName.toLowerCase())) {
                    // Replace the element with its content (preserves the text inside the tag)
                    child.replaceWith(...child.childNodes);
                } else if (child.nodeType === Node.ELEMENT_NODE) {
                    // Recursively clean the children of allowed elements
                    cleanNode(child);
                }
            }
        }

        // Clean the root node
        cleanNode(tempDiv);

        // Return the cleaned HTML as a string
        return tempDiv.innerHTML;
    },

    nl2br(str) {
        return str.replace(/\n/g, '<br>');
    }
}
export default gh
